// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1ZPta","title":"card_title__2q6Ge","inActive":"card_inActive__1T5q7"};